import type { SdkError } from "@microsoft/teams-js";
import type { DatapointStatus, TraceErrorObject } from "owa-analytics-types";
import { ensureCaughtErrorIsError } from "owa-errors";

export function normalizeTeamsSdkError(error: unknown, datapointStatus: DatapointStatus): TraceErrorObject {
    const normalizedError: TraceErrorObject = ensureCaughtErrorIsError(error);
    normalizedError.datapointStatus = datapointStatus;
    
    if (isTeamsSdkError(error)) {
        normalizedError.additionalInfo = {
            ...normalizedError.additionalInfo,
            teamsSdkErrorCode: error.errorCode,
        };
    }
    
    return normalizedError;
}

export function isTeamsSdkError(error: unknown): error is SdkError {
    return (error !== null &&
        typeof error === "object" &&
        typeof (error as Partial<SdkError>).errorCode === "number");
}
